exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".story-text{width:100%}.story-text .text{color:#fff;font-size:1.125em;line-height:1.5em;font-family:Abhaya Libre,serif}.story-text .text span.underlined{text-decoration:underline;font-family:$FONT_PRIMALY}.story-text .text span.bold{font-size:18px;font-family:Poppins,sans-serif}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-5eb3f47a","scoped":false,"hasInlineConfig":false}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/content-elements/story-text.vue
// module id = 582
// module chunks = 0